var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('contact-form',{attrs:{"initialContact":_vm.contact,"title":'contacts.edit_contact'},on:{"save":_vm.save,"cancel":_vm.cancel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }